import { all } from 'redux-saga/effects';
import fetchOtherDocuments from './fetchOtherDocuments';

export default function* () {
    yield all([fetchOtherDocuments()]);
}
